import { render, staticRenderFns } from "./PaymentTransfer.vue?vue&type=template&id=31c3f3a6&"
import script from "./PaymentTransfer.vue?vue&type=script&lang=js&"
export * from "./PaymentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports